import { render, staticRenderFns } from "./CreateMenteeProfileAsMentorModal.vue?vue&type=template&id=3d2772d0&"
import script from "./CreateMenteeProfileAsMentorModal.vue?vue&type=script&lang=js&"
export * from "./CreateMenteeProfileAsMentorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports